import { useState, useRef, useEffect } from "react";
import classes from "./MultiSelect.module.css";
import Check from "../../svg/Check.svg";
import Cross from "../../svg/Cross.svg";
import { truncateWithTooltip } from "../../helpers/common";

export default function MultiSelect({
  options,
  selected,
  onChange,
  placeholder = "Please Select",
  label,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (value) => {
    const clickedGroup = options.find((group) => group.group_id === value);
    const alreadySelected = selected.some((group) => group.group_id === value);
    if (alreadySelected) {
      onChange(selected.filter((item) => item.group_id !== value));
    } else {
      onChange([...selected, clickedGroup]);
    }
  };

  const handleRemove = (value, e) => {
    e.stopPropagation();
    onChange(selected.filter((item) => item.group_id !== value));
  };

  const isCurrentGroupSelected = (group_id) => {
    return selected.some((item) => item.group_id === group_id);
  };

  return (
    <div className="w-full">
      {label && <label className={classes.label}>{label}</label>}
      <div className="relative" ref={containerRef}>
        <div
          onClick={() => setIsOpen(!isOpen)}
          className={classes.select_group}
        >
          {selected.length > 0 ? (
            selected.map((option) => (
              <span key={option.group_name} className={classes.selected_items}>
                {truncateWithTooltip(option.group_name)}
                <button
                  type="button"
                  onClick={(e) => handleRemove(option.group_id, e)}
                  className={classes.remove_button}
                >
                  <img src={Cross} alt="remove item" />
                </button>
              </span>
            ))
          ) : (
            <span className="form-control">{placeholder}</span>
          )}
        </div>

        {isOpen && (
          <div className={classes.list_container}>
            <ul className={classes.list}>
              {options.map((option) => {
                return (
                  <li
                    key={option.value}
                    onClick={() => handleSelect(option.value)}
                    className={classes.list_item}
                  >
                    <span>{truncateWithTooltip(option.label, 40)}</span>
                    {isCurrentGroupSelected(option.value) && (
                      <span>
                        <img src={Check} />
                      </span>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
